import { Component, DestroyRef, inject } from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {PreordersDeliveriesService} from "./services/preorders-deliveries.service";
import {UserService} from "../../core/user/services/user.service";

@Component({
  selector: 'app-preorders-deliveries',
  standalone: false,
  templateUrl: './preorders-deliveries.component.html',
  styleUrl: './preorders-deliveries.component.scss'
})
export class PreordersDeliveriesComponent {

  preorders: any[] = [];
  preordersDeliveriesService = inject(PreordersDeliveriesService);
  userService = inject(UserService);
  private destroyRef = inject(DestroyRef);
  private selectedIdf: any;

  displayedColumns: string[] = ["pzn","product_name","comment","delivery_date","tour","qty",]

  constructor() {

  }

  ngOnInit() {
    this.userService.selectedIdf$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(idf => {
      if (idf) {
        this.selectedIdf = idf;
        this.getPreordersDeliveries(idf)
      }
    });
  }

  getPreordersDeliveries(idf: string) {
    this.preordersDeliveriesService.loadPreordersDeliveries(idf).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        this.preorders = data.return_object;
      }
    )
  }
}
